<template>
<e-chart ref="chart" />
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY} from './FactorCharts/chartStyle'
export default {
  name: 'AQIBubbleChart',
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      colors: [
        '#3ba272',
        '#F44336',
        '#7E57C2',
        '#29B6F6',
        '#26A69A',
        '#8BC34A',
        '#FFEE58',
        '#FF9800',
        '#607D8B',
        '#795548',
        '#EC407A',
        '#AB47BC',
        '#26C6DA',
        '#fe7300',
        '#66BB6A',
        '#D4E157',
        '#FFCA28'
      ]
    }
  },
  methods: {
    render (isReal) {
      let {data: {xAxis, series}} = this
      let date = xAxis.map(el => new Date(el).getTime())
      let aqi = [0, 10]
      if (series.length > 0) {
        aqi = series.map(el => {
          let temp = []
          el.data.forEach(item => {
            const value = item[1]

            if (Number.isFinite(value)) {
              temp.push(value)
            }
          })
          return temp
        }).flat()
      }

      let chartOpt = {
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          formatter: function (param) {
            var value = param.value
            return `
              <div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">
                <h4 style="margin: 2px;">${param.marker}${param.seriesName}</h4>
                <h5 style="margin: 2px;">${new Date(value[0]).format('YYYY-MM-DD')}</h5>
                <h5 style="margin: 2px;">污染等级：${value[2]}</h5>
                <p style="margin: 1px;font-size: 14px;">AQI指数： ${value[1]}</p>
                <p style="margin: 1px;font-size: 14px;">${value[3]}</p>
                <p style="margin: 1px;font-size: 14px;">${value[4]}</p>
                <p style="margin: 1px;font-size: 14px;">${value[5]}</p>
              </div>
            `
          }
        },
        legend: {
          itemGap: 20,
          textStyle: {
            fontSize: 14
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        grid: [{
          top: 50,
          right: 150,
          bottom: 50,
          left: 50,
          containLabel: true
        }],
        xAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          min: Math.min(...date) - 86400000,
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: value => {
              return new Date(value).format('YYYY-MM-DD')
            },
            inside: false,
            color: 'black',
            fontSize: '10px'
          }
        },
        yAxis: {
          type: 'value',
          nameGap: 10,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          }
        },
        visualMap: [{
          left: 'right',
          top: '10%',
          dimension: 1,
          min: Math.min(...aqi),
          max: Math.max(...aqi) + 10,
          itemWidth: 30,
          itemHeight: 120,
          calculable: true,
          precision: 0.1,
          text: ['圆形大小： AQI'],
          textGap: 30,
          inRange: {
            symbolSize: [10, 70]
          },
          outOfRange: {
            symbolSize: [10, 70],
            color: ['rgba(255,255,255,0.4)']
          },
          controller: {
            inRange: {
              color: ['#63ccca']
            },
            outOfRange: {
              color: ['#999']
            }
          }
        }, {
          left: 'right',
          bottom: '5%',
          dimension: 1,
          min: Math.min(...aqi),
          max: Math.max(...aqi),
          itemHeight: 120,
          text: ['明暗：AQI'],
          textGap: 30,
          inRange: {
            colorLightness: [0.9, 0.5]
          },
          outOfRange: {
            color: ['rgba(255,255,255,0.4)']
          },
          controller: {
            inRange: {
              color: ['#63ccca']
            },
            outOfRange: {
              color: ['#999']
            }
          }
        }],
        color: this.colors,
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          start: 0,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 9,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }],
        series: series
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/AQIBubbleChart.vue